import { contactsConstants } from '@constants/contacts';
import { contactsService } from '@services';

function request() {
    return { type: contactsConstants.CONTACTS_FETCH };
}

function success(data) {
    return { type: contactsConstants.CONTACTS_SUCCESS, data };
}

function failure(message) {
    return { type: contactsConstants.CONTACTS_ERROR, message };
}

const get = (params, page = 0, pageSize = 10) => {
    return dispatch => {
        dispatch(request());
        contactsService.get(params, page, pageSize).then(
            data => dispatch(success(data)),
            error => {
                if (!error.aborted) {
                    dispatch(failure());
                }
            },
        );
    };
};

const setContacts = data => {
    return { type: contactsConstants.SET_CONTACTS, data };
};

const getContact = id => {
    return dispatch => {
        dispatch(setContactLoading());
        contactsService.getContact(id).then(
            data => dispatch(setContact(data)),
            () => dispatch(setContact(null)),
        );
    };
};

const setContactLoading = () => {
    return { type: contactsConstants.SET_CONTACT_LOADING };
};

const setContact = data => {
    return { type: contactsConstants.SET_CONTACT, data };
};

const setContactDrawer = payload => {
    return { type: contactsConstants.SET_CONTACT_DRAWER, payload };
};

const setSearchedContacts = data => {
    return { type: contactsConstants.SEARCHED_CONTACTS_SUCCESS, data };
};

const getSearchedContacts = (params, page = 0, pageSize = 10) => {
    return dispatch => {
        dispatch(request());
        contactsService.get(params, page, pageSize).then(
            data => dispatch(setSearchedContacts(data)),
            error => {
                if (!error.aborted) {
                    dispatch(failure());
                }
            },
        );
    };
};

const resetSearchedContacts = () => {
    return { type: contactsConstants.SEARCHED_CONTACTS_RESET };
};

const setBulkEditData = data => {
    return { type: contactsConstants.BULK_EDIT_DATA_SUCCESS, data };
};

const getBulkEditData = params => {
    return dispatch => {
        contactsService.getBulkEditData(params).then(data => dispatch(setBulkEditData(data)));
    };
};

const resetContacts = () => {
    return { type: contactsConstants.RESET_CONTACTS };
};

const setContactDeleteModal = payload => {
    return { type: contactsConstants.SET_CONTACT_DELETE_MODAL, payload };
};

const setContactEditModal = payload => {
    return { type: contactsConstants.SET_CONTACT_EDIT_MODAL, payload };
};

const setContactMergeModal = payload => {
    return { type: contactsConstants.SET_CONTACT_MERGE_MODAL, payload };
};

const setContactInitConversationModal = payload => {
    return { type: contactsConstants.SET_CONTACT_INIT_CONVERSATION_MODAL, payload };
};

export const contactsActions = {
    get,
    setContacts,
    resetContacts,
    setContact,
    getContact,
    getSearchedContacts,
    resetSearchedContacts,
    getBulkEditData,
    setBulkEditData,
    setContactDrawer,
    setContactDeleteModal,
    setContactEditModal,
    setContactMergeModal,
    setContactInitConversationModal,
};
